import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { MasterEventApiData } from '../../hooks/useMasterEvent';

type InfoSectionProps = {
  name: string,
  url: string,
  title: string,
};

const InfoSection = ({
  name,
  title,
  url,
}: InfoSectionProps) => {
  const styles = useStyles();

  if (!name) {
    return null;
  }

  return (
    <div
      itemScope
      itemProp='organizer'
      itemType='http://schema.org/Person'
    >
      <div className={styles.title}>
        {title}
      </div>

      {url ? (
        <a
          target='_blank'
          rel="noopener noreferrer"
          href={url}
          className={styles.link}
        >
          {name}
        </a>
      ) : (
        <Typography itemProp='name' className={styles.text}>
          {name}
        </Typography>
      )}
    </div>
  );
}

type OrgAndTimerProps = {
  event: MasterEventApiData['currentRace']
};

export const OrgAndTimer = ({ event }: OrgAndTimerProps) => {
  const { t } = useTranslation();

  if (!event.isPublishedAthlinks) {
    return null;
  }

  return (
    <>
      {event.organization && <InfoSection title={t('Organizer')} {...event.organization} />}

      {event.timer && <InfoSection title={t('Timer')} {...event.timer} />}
    </>
  );
};
